<div class="pt-20 sm:pt-24 md:pt-28 lg:pt-32">
  <div class="container mx-auto px-4 py-4">
    @if(isLoading()){
    <!-- Skeleton Loader -->
    <div class="animate-pulse">
      <!-- Arrow back skeleton -->
      <div class="mb-10">
        <div class="h-8 w-24 bg-gray-300 rounded"></div>
      </div>

      <div class="flex flex-col md:flex-row gap-6">
        <!-- Columna izquierda skeleton -->
        <div class="w-full md:w-7/12 space-y-6">
          <!-- Información de entrega skeleton -->
          <div class="bg-white rounded-lg p-6 shadow-sm">
            <div class="h-6 bg-gray-300 rounded w-48 mb-4"></div>
            <div class="space-y-3">
              <div class="h-4 bg-gray-200 rounded w-full"></div>
              <div class="h-4 bg-gray-200 rounded w-3/4"></div>
              <div class="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>

          <!-- Tu pedido skeleton -->
          <div class="bg-white rounded-lg p-6 shadow-sm">
            <div class="h-6 bg-gray-300 rounded w-32 mb-4"></div>
            <div class="space-y-4">
              <div class="flex items-center space-x-4">
                <div class="h-16 w-16 bg-gray-300 rounded"></div>
                <div class="flex-1 space-y-2">
                  <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div class="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
                <div class="h-6 w-16 bg-gray-300 rounded"></div>
              </div>
              <div class="flex items-center space-x-4">
                <div class="h-16 w-16 bg-gray-300 rounded"></div>
                <div class="flex-1 space-y-2">
                  <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div class="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
                <div class="h-6 w-16 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>

          <!-- Métodos de pago skeleton (desktop) -->
          <div class="hidden md:block bg-white rounded-lg p-6 shadow-sm">
            <div class="h-6 bg-gray-300 rounded w-40 mb-4"></div>
            <div class="grid grid-cols-2 gap-4">
              <div class="h-12 bg-gray-200 rounded"></div>
              <div class="h-12 bg-gray-200 rounded"></div>
              <div class="h-12 bg-gray-200 rounded"></div>
              <div class="h-12 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        <!-- Columna derecha skeleton -->
        <div class="w-full md:w-5/12 space-y-6">
          <!-- Propina skeleton -->
          <div class="bg-white rounded-lg p-6 shadow-sm">
            <div class="h-6 bg-gray-300 rounded w-36 mb-4"></div>
            <div class="space-y-3">
              <div class="h-4 bg-gray-200 rounded w-full"></div>
              <div class="h-10 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          <!-- Resumen pedido skeleton -->
          <div class="bg-white rounded-lg p-6 shadow-sm">
            <div class="h-6 bg-gray-300 rounded w-40 mb-4"></div>
            <div class="space-y-3">
              <div class="flex justify-between">
                <div class="h-4 bg-gray-200 rounded w-24"></div>
                <div class="h-4 bg-gray-200 rounded w-16"></div>
              </div>
              <div class="flex justify-between">
                <div class="h-4 bg-gray-200 rounded w-32"></div>
                <div class="h-4 bg-gray-200 rounded w-16"></div>
              </div>
              <div class="flex justify-between">
                <div class="h-4 bg-gray-200 rounded w-20"></div>
                <div class="h-4 bg-gray-200 rounded w-16"></div>
              </div>
              <hr class="my-3">
              <div class="flex justify-between">
                <div class="h-5 bg-gray-300 rounded w-16"></div>
                <div class="h-5 bg-gray-300 rounded w-20"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Métodos de pago skeleton (móvil) -->
      <div class="block md:hidden mt-6 bg-white rounded-lg p-6 shadow-sm">
        <div class="h-6 bg-gray-300 rounded w-40 mb-4"></div>
        <div class="space-y-3">
          <div class="h-12 bg-gray-200 rounded"></div>
          <div class="h-12 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
    }@else if(isItemsCart()){

    <div class="mb-10">
      <shared-arrow-back></shared-arrow-back>
    </div>

    <div class="flex flex-col md:flex-row gap-6">
      <!-- Columna izquierda: Tu pedido e Información de entrega -->
      <div class="w-full md:w-7/12 space-y-6">
        <div class="mb-5">
          <detail-orden-checkout-informacion-entrega
            (selectedAddressChange)="onSelectedAddressChange($event)"
          ></detail-orden-checkout-informacion-entrega>
        </div>
        <div class="mb-5">
          <detail-order-checkout-tu-pedido></detail-order-checkout-tu-pedido>
        </div>

        <!-- Métodos de pago en desktop (visible solo en md y superior) -->
        @if(canBuy()){
        <div class="hidden md:block">
          <shared-metodos-pagos></shared-metodos-pagos>
        </div>
        }@else {
        <div class="hidden md:block">
          <p class="font-bold text-red-500">
          Tienes un saldo negativo en tus créditos. Para continuar realizando compras, es necesario liquidar tu deuda pendiente.
          </p>
        </div>
        }
      </div>

      <!-- Columna derecha: Resumen del pedido y Método de pago -->
      <div class="w-full md:w-5/12 space-y-6">
        <div class="mb-5">
          <detail-orden-checkout-propina-repartidor></detail-orden-checkout-propina-repartidor>
          <detail-orden-checkout-resumen-pedido></detail-orden-checkout-resumen-pedido>
          <mercado-pago-text-detail-shop></mercado-pago-text-detail-shop>
        </div>
      </div>
    </div>

    <!-- Métodos de pago en móvil (visible solo en tamaños menores a md) -->
    @if(canBuy()){
    <div class="block md:hidden mt-6">
      <shared-metodos-pagos></shared-metodos-pagos>
    </div>
    }@else {
    <div class="block md:hidden mt-6">
      <p class="font-bold text-red-500">
      Tienes un saldo negativo en tus créditos. Para continuar realizando compras, es necesario liquidar tu deuda pendiente.
      </p>
    </div>
    }
    }@else {
    <div class="flex flex-col items-center">
      <i class="fa-solid fa-cart-shopping text-6xl text-yellow-400"></i>
      <p class="text-2xl font-bold mt-4">Tu carrito está vacío</p>
      <p class="text-lg text-gray-600 mt-2">¡No te quedes sin nada!</p>
    </div>
    }
  </div>
</div>

<modal-view-multiplicador #modalMultiplicador></modal-view-multiplicador>
